var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoneyBack = function SvgMoneyBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0C000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.167 14.667c0 .736-1.791 1.333-4 1.333-2.21 0-4-.597-4-1.333m8 0c0-.737-1.791-1.334-4-1.334-2.21 0-4 .597-4 1.334m8 0v2.666m-8-2.666v2.666c0 .737 1.79 1.334 4 1.334 2.209 0 4-.597 4-1.334m2.666 1.258c0 .736-1.79 1.333-4 1.333-2.209 0-4-.597-4-1.333v2.666m8-2.666c0-.58-1.113-1.075-2.666-1.258m2.666 1.258v2.666c0 .737-1.79 1.334-4 1.334-2.209 0-4-.597-4-1.334m-2.666 1.258c0 .736 1.79 1.333 4 1.333 2.209 0 4-.597 4-1.333v2.667c0 .736-1.791 1.333-4 1.333-2.21 0-4-.597-4-1.333v-2.667Zm0 0c0-.58 1.113-1.075 2.666-1.258",
    stroke: "#111",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20c0-7.456-6.044-13.5-13.5-13.5a13.45 13.45 0 0 0-9 3.438M10.9 6.5v2.7a1.5 1.5 0 0 0 1.5 1.5h2.7M7 20c0 7.456 6.044 13.5 13.5 13.5 3.458 0 6.612-1.3 9-3.438m.6 3.438v-2.7a1.5 1.5 0 0 0-1.5-1.5h-2.7",
    stroke: "#111",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgMoneyBack;